import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Dropdown } from './Dropdown';

export type ViewType = 'simpleView' | 'professionalView';

type ViewTypeDropdownProps = {
	defaultProfessional?: boolean;
	onChange: (viewType: ViewType) => void;
};

export const ViewTypeDropdown = ({ defaultProfessional = false, onChange }: ViewTypeDropdownProps) => {
	const { t } = useTranslation();
	const [viewType, setViewType] = useState<ViewType>(defaultProfessional ? 'professionalView' : 'simpleView');

	useEffect(() => {
		setViewType(defaultProfessional ? 'professionalView' : 'simpleView');
	}, [defaultProfessional]);

	useEffect(() => {
		onChange(viewType);
	}, [onChange, viewType]);

	const options = useMemo(
		() => [
			{ value: 'simpleView', label: t('userPanel.settings.simpleView') },
			{ value: 'professionalView', label: t('userPanel.settings.professionalView') },
		],
		[t]
	);

	return <Dropdown value={viewType} onChange={(event) => setViewType(event.value as ViewType)} options={options} />;
};
